import { useEffect, useState } from 'react';
import './SideSheet.scss';
import { SidesheetProps } from '../../types';

const SideSheet = ({ header, children, active, onClose, cancelBtn, hideCloseButton }: SidesheetProps) => {
  const closeSideSheet = (e: any) => {
    if (e.target.className === 'side-sheet') {
      setTransition(false);
      setTimeout(() => onClose(), 200);
    }
  };
  const [transition, setTransition] = useState<boolean>();
  useEffect(() => {
    if (active) {
      setTimeout(() => {
        setTransition(true);
      }, 50);
    } else {
      setTimeout(() => {
        setTransition(false);
      }, 50);
    }
  }, [active]);

  return (
    <>
      {active && (
        <div
          className="side-sheet"
          onClick={closeSideSheet}
          {...(transition
            ? { style: { ...{ opacity: '1', zIndex: '4', transition: '500ms' } } }
            : { style: { ...{ opacity: '0', zIndex: '-1', transition: '500ms' } } })}
        >
          <div
            className="side-sheet-body"
            {...(transition
              ? { style: { ...{ right: '0px', transition: '1000ms' } } }
              : { style: { ...{ right: '-800px', transition: '1000ms' } } })}
          >
            <div className="head">
              {!hideCloseButton && (
                <button
                  className="close-button"
                  onClick={() => {
                    setTransition(false);
                    setTimeout(() => {
                      onClose();
                    }, 300);
                  }}
                >
                  <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="19.5" cy="19.5" r="19.5" fill="#F1F2F4" />
                    <line x1="14.3536" y1="13.6464" x2="26.3536" y2="25.6464" stroke="#32343B" />
                    <line x1="13.6464" y1="25.6464" x2="25.6464" y2="13.6464" stroke="#32343B" />
                  </svg>
                </button>
              )}

              {header && <p>{header}</p>}
            </div>
            <div id="body">
              {children}
              {cancelBtn && (
                <div
                  className="cancel-button"
                  onClick={() => {
                    setTransition(false);
                    setTimeout(() => {
                      onClose();
                    }, 300);
                  }}
                >
                  <button>Cancel</button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SideSheet;
